export default __webpack_public_path__ + "static/media/classroom-background-card.fd5a8a9f.png";